import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@shared/data-access';
import { CreateOfficerRequest } from '../models/officer-details-request.models';
import { CreateOfficerResponse } from '../models/officer-details-response.models';

@Injectable({
  providedIn: 'root',
})
export class CreateOfficerService {
  constructor(private api: BaseApiService) {}

  createOfficer(officer: CreateOfficerRequest): Observable<CreateOfficerResponse> {
    return this.api.post(`api/users`, officer);
  }
}
